export default __webpack_public_path__ + "static/top40-9c5be50dd2591a1c7b15b632df72ceb6.webp";